import React from 'react'
import { InformationList } from 'spa/member/components/Top/InformationList'
import { breakpointsV2 } from 'spa/config/styled'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import { ActionGuideWithBackground } from 'spa/member/components/Top/ActionGuideWithBackground'
import { ServiceFeatures } from 'spa/member/components/Top/ServiceFeatures'
import { ServiceFlow } from 'spa/member/components/Top/ServiceFlow'
import Watching from 'images/spa/top/watching.svg'
import Clock from 'images/spa/top/clock.svg'
import { useIsMobile } from 'spa/member/hooks/v2/useIsMobile'
import { MainVisual } from 'spa/member/components/Top/MainVisual'
import { FaqList } from 'spa/member/components/Top/FaqList'
import { BrandSlider } from 'spa/member/components/Top/BrandSlider'
import SpCompanyLogos from 'images/dashboard/sp_company_logos.png'
import { Banners } from 'spa/member/components/Top/Banners'
import { HelpfulInformation } from 'spa/member/components/Top/HelpfulInformation'
import styles from './Top.module.scss'
import { QuickSignupPanel } from 'spa/member/components/Top/QuickSignupPanel'
import { UserRegistrationButton } from 'spa/member/components/Top/UserRegistrationButton'

export const StyledTop: React.FC = () => {
  const sectionPadding = 'px-M py-2XL tablet:px-3XL tablet:py-4XL desktop:px-5XL'
  const windowWidth = useWindowWidth()
  const isDesktop = breakpointsV2.desktop <= windowWidth
  const isMobile = useIsMobile()

  return (
      <main className="flex flex-row-reverse justify-center">
        {isDesktop ? (
          <section className={`flex-shrink-0 block border-l-1 border-member-gray-20 ${styles.signUpArea}`}>
            <div className={`px-XL py-XL sticky ${styles.quickSignupPanelArea}`}>
              <QuickSignupPanel />
            </div>
          </section>
        ) : (
          <section className={`flex flex-row flex-grow justify-center border-l ${styles.quickSignupPanelMobile}`}>
            <UserRegistrationButton />
          </section>
        )}
        <section className="flex flex-col overflow-hidden desktop:flex-grow items-center">
          <MainVisual />
          <section className={`relative w-full px-M py-2XL border-t-1 border-b-1 border-member-tech-gray-20 tablet:p-0 tablet:border-b-0 tablet:block ${styles.brandSliderContainer}`}>
            <img className={`m-auto tablet:hidden ${styles.SpCompanyLogos}`} src={SpCompanyLogos} alt="クライアント一覧" />
            <div className={`hidden absolute top-0 left-0 w-full overflow-hidden tablet:block tablet:border-b-1 ${styles.brandSlider}`}>
              <BrandSlider />
            </div>
          </section>
          <div className={`${styles.contents}`}>
            <section className={`flex flex-col items-center ${sectionPadding}`} id="service-features">
              <ServiceFeatures />
            </section>
            <section className={`flex flex-col items-center w-full bg-member-background-100 ${sectionPadding}`} id="service-flow">
              <ServiceFlow />
            </section>
            <section className="w-full px-M py-2XL tablet:px-3XL tablet:py-4XL desktop:px-4XL">
              <ActionGuideWithBackground title={`自分にあった働き方を${isMobile ? '\n' : ''}見つけよう。`}
                                         description={`クラウドワークス テックなら${isMobile ? '\n' : ''}リモートワーク案件数、業界トップクラス！\nフリーランスが柔軟にはたらけるお仕事を${isMobile ? '\n' : ''}素早くご提案します。`}
                                         className="mx-auto" headerClassName="pl-S" // 。の右側の余白の分、padding-leftを追加している
                                         image={Watching} imageClassName="left-0 -bottom-6" imageWidth={isDesktop ? '241' : '148'} />
            </section>
            <section className={`flex flex-col w-full items-center ${sectionPadding}`} id="service-faq">
              <FaqList />
            </section>
            <section className={`w-full ${sectionPadding}`} id="service-info">
              <HelpfulInformation />
            </section>
            <section className={`flex justify-center w-full ${sectionPadding} ${styles.informationList}`}>
              <InformationList className="flex-grow" />
            </section>
            <section className="w-full px-M py-2XL tablet:px-3XL tablet:py-4XL desktop:px-4XL">
              <ActionGuideWithBackground title="60秒で簡単登録！"
                                         description={`登録後、お仕事探しがすぐに始められます。\n働きやすいリモートワーク案件が${isMobile ? '\n' : ''}豊富に揃っています。`}
                                         className="mx-auto"
                                         image={Clock} imageClassName="left-8 -bottom-6" imageWidth={isDesktop ? '223' : '154'} />
            </section>
            <section className={`flex justify-center ${sectionPadding}`}>
              <Banners className={styles.banners} />
            </section>
          </div>
        </section>
      </main>
  )
}
